import type React from 'react';

import { Grid, Row, GridContainer } from '@xing-com/xing-grid';

type LoggedOutPageProps = {
  children?: React.ReactNode;
};
export const LoggedOutPage: React.FC<LoggedOutPageProps> = ({ children }) => {
  return (
    <GridContainer type="standard">
      <Grid>
        <Row>{children}</Row>
      </Grid>
    </GridContainer>
  );
};
